import { render } from "./doughnutChartHowToFix.vue?vue&type=template&id=1b453acf&scoped=true"
import script from "./doughnutChartHowToFix.vue?vue&type=script&lang=js"
export * from "./doughnutChartHowToFix.vue?vue&type=script&lang=js"

import "./doughnutChartHowToFix.vue?vue&type=style&index=0&id=1b453acf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b453acf"]])

export default __exports__